module.exports = __webpack_public_path__ + "static/media/algorand-ipfs.a72e8a82.jpg";